(function () {
  var root = document.querySelector('[data-pw-diagnostic]');
  if (!root) return;

  var form = root.querySelector('[data-pw-diagnostic-form]');
  var input = root.querySelector('[data-pw-diagnostic-input]');
  var submit = root.querySelector('[data-pw-diagnostic-submit]');
  var error = root.querySelector('[data-pw-diagnostic-error]');
  var loading = root.querySelector('[data-pw-diagnostic-loading]');
  var status = root.querySelector('[data-pw-diagnostic-status]');
  var progress = root.querySelector('[data-pw-diagnostic-progress]');
  var result = root.querySelector('[data-pw-diagnostic-result]');

  var messages = ['Analyse du site…', 'Analyse de la visibilité…', 'Analyse de la conversion…', 'Recherche des opportunités…'];
  var timer;

  function showError(message) {
    error.textContent = message;
    error.hidden = false;
  }

  function normalizeUrl(value) {
    var raw = value.trim();
    if (!/^https?:\/\//i.test(raw)) raw = 'https://' + raw;
    var url = new URL(raw);
    var host = url.hostname.toLowerCase();
    var privateIp = /^(127\.|10\.|0\.|169\.254\.|192\.168\.|172\.(1[6-9]|2\d|3[01])\.)/;
    if (!['http:', 'https:'].includes(url.protocol) || host === 'localhost' || host.endsWith('.local') || privateIp.test(host) || !host.includes('.')) throw new Error('invalid');
    url.hash = '';
    return url;
  }

  function formatScore(value) { return String(Math.round(value)); }

  function hasText(items, pattern) {
    return Array.isArray(items) && items.some(function (item) { return pattern.test(String(item || '')); });
  }

  function buildChecks(response, url) {
    var data = response.data || {};
    var headers = response.headers || {};
    var links = Array.isArray(data.links) ? data.links : [];
    var images = Array.isArray(data.images) ? data.images : [];
    var buttons = Array.isArray(data.buttons) ? data.buttons : [];
    var h1 = Array.isArray(data.h1) ? data.h1 : [];
    var h2 = Array.isArray(data.h2) ? data.h2 : [];
    var internalLinks = links.filter(function (link) { try { return new URL(link, url.href).hostname === url.hostname; } catch (e) { return false; } });
    var imagesWithAlt = images.filter(function (html) { return /\salt=(['"])(?!\1).+?\1/i.test(String(html)); });
    var imagesWithDimensions = images.filter(function (html) { return /\swidth=(['"])\d+\1/i.test(String(html)) && /\sheight=(['"])\d+\1/i.test(String(html)); });
    var lazyImages = images.filter(function (html) { return /\sloading=(['"])lazy\1/i.test(String(html)); });
    var ctaPattern = /contact|devis|réserver|reserver|rendez-vous|rdv|appel|découvrir|demander|commencer|acheter|essayer/i;

    return [
      [url.protocol === 'https:', 'Crédibilité', 'Site accessible et sécurisé', 'Sécurité HTTPS', 'La connexion sécurisée du site mérite d’être renforcée.', 1.2],
      [response.status === 'success' && response.statusCode === 200, 'Performance', 'Page correctement accessible', 'Accessibilité technique', 'La page principale ne répond pas de façon totalement fiable.', 1.1],
      [Boolean(data.title && data.title.length >= 10 && data.title.length <= 70), 'SEO', 'Titre de page bien renseigné', 'Titre de page', 'Le titre de la page peut être mieux calibré pour les moteurs de recherche.', 1],
      [Boolean(data.description && data.description.length >= 50 && data.description.length <= 170), 'SEO', 'Description pour les moteurs présente', 'Meta description', 'La description affichée dans les résultats de recherche peut être optimisée.', 1],
      [h1.length === 1 && String(h1[0]).trim().length > 8, 'SEO', 'Titre principal clairement structuré', 'Titre principal H1', 'Le titre principal de la page peut être clarifié ou mieux structuré.', 1],
      [h2.length >= 2, 'SEO', 'Contenu organisé en sections', 'Structure du contenu', 'Les sections de la page peuvent être mieux hiérarchisées.', .8],
      [Boolean(data.viewport), 'Mobile', 'Affichage mobile configuré', 'Configuration mobile', 'La configuration de l’affichage mobile est à vérifier.', 1.1],
      [Boolean(data.og), 'SEO', 'Partage social configuré', 'Open Graph', 'La présentation du site lors d’un partage social peut être améliorée.', .7],
      [Boolean(data.canonical), 'SEO', 'Adresse canonique définie', 'Page canonique', 'L’adresse de référence de la page peut être mieux indiquée.', .8],
      [Boolean(data.lang), 'SEO', 'Langue de page déclarée', 'Langue de la page', 'La langue principale de la page doit être déclarée plus clairement.', .6],
      [Boolean(data.jsonld && data.jsonld.length), 'SEO', 'Données structurées présentes', 'Données structurées', 'Des données structurées peuvent aider les moteurs à mieux comprendre l’activité.', .9],
      [links.length >= 5, 'SEO', 'Navigation détectée', 'Maillage de la page', 'La page peut proposer davantage de chemins utiles vers les contenus importants.', .8],
      [internalLinks.length >= 3, 'SEO', 'Liens internes présents', 'Liens internes', 'La structure des liens internes peut être renforcée.', .9],
      [hasText(buttons, ctaPattern), 'Conversion', 'Appel à l’action détecté', 'Appel à l’action', 'L’action principale pourrait être plus visible et plus explicite.', 1.2],
      [Boolean(data.forms && data.forms.length), 'Conversion', 'Formulaire de contact détecté', 'Prise de contact', 'Un parcours de contact direct peut faciliter le passage à l’action.', .9],
      [Boolean(data.booking && data.booking.length), 'Conversion', 'Prise de rendez-vous disponible', 'Prise de rendez-vous', 'Un accès direct à la réservation peut raccourcir le parcours.', .8],
      [Boolean(data.emails && data.emails.length), 'Crédibilité', 'Adresse e-mail disponible', 'Coordonnées visibles', 'Une adresse e-mail visible peut renforcer la confiance et faciliter le contact.', .6],
      [Boolean(data.socials && data.socials.length), 'Crédibilité', 'Présence sociale reliée', 'Présence sociale', 'Des liens vers les réseaux actifs peuvent renforcer les signaux de confiance.', .5],
      [images.length === 0 || imagesWithAlt.length / images.length >= .8, 'Mobile', 'Images correctement décrites', 'Images et accessibilité', 'Certaines images gagneraient à être mieux décrites.', .8],
      [images.length === 0 || imagesWithDimensions.length / images.length >= .8, 'Performance', 'Dimensions des images renseignées', 'Stabilité visuelle', 'Certaines images n’indiquent pas leurs dimensions, ce qui peut déplacer le contenu pendant le chargement.', .8],
      [images.length < 3 || lazyImages.length > 0, 'Performance', 'Chargement différé détecté', 'Chargement des images', 'Le chargement différé des images hors écran peut être étudié.', .7],
      [Boolean(data.testimonials && data.testimonials.length), 'Crédibilité', 'Éléments de preuve détectés', 'Preuves et témoignages', 'Des avis ou preuves clients plus visibles peuvent renforcer la confiance.', .9],
      [Boolean(data.faq && data.faq.length), 'Conversion', 'Questions fréquentes disponibles', 'Réponses aux objections', 'Une FAQ peut répondre plus tôt aux questions qui freinent la décision.', .6],
      [Boolean(headers['strict-transport-security']), 'Crédibilité', 'Protection HTTPS renforcée', 'En-tête de sécurité', 'La politique de sécurité HTTPS peut être renforcée.', .5]
    ];
  }

  function render(response, url) {
    if (!response || response.status !== 'success' || !response.data) throw new Error('unavailable');
    var checks = buildChecks(response, url);
    var totalWeight = checks.reduce(function (sum, check) { return sum + check[5]; }, 0);
    var earnedWeight = checks.reduce(function (sum, check) { return sum + (check[0] ? check[5] : 0); }, 0);
    var failed = checks.filter(function (check) { return !check[0]; });
    var passed = checks.filter(function (check) { return check[0]; });
    var current = Math.round(earnedWeight / totalWeight * 100);
    var potential = Math.min(100, Math.round((earnedWeight + (totalWeight - earnedWeight) * .75) / totalWeight * 100));
    var gain = Math.max(0, potential - current);

    root.querySelector('[data-pw-diagnostic-domain]').textContent = url.hostname.replace(/^www\./, '');
    root.querySelector('[data-pw-diagnostic-score]').textContent = formatScore(current);
    root.querySelector('[data-pw-diagnostic-potential]').textContent = formatScore(potential);
    root.querySelector('[data-pw-diagnostic-gain]').textContent = 'Marge d’optimisation indicative : +' + formatScore(gain) + ' point' + (gain > 1 ? 's' : '');
    root.querySelector('[data-pw-diagnostic-impact]').textContent = failed.length + ' SIGNAUX À VÉRIFIER';
    root.querySelector('[data-pw-diagnostic-cta-current]').textContent = formatScore(current);
    root.querySelector('[data-pw-diagnostic-cta-potential]').textContent = formatScore(potential);
    root.querySelector('[data-pw-diagnostic-summary]').textContent = current >= 84
      ? 'Votre site possède une base solide. Quelques optimisations ciblées peuvent encore renforcer son efficacité.'
      : current >= 60
        ? 'Votre site possède une bonne base, mais plusieurs opportunités peuvent encore améliorer son efficacité.'
        : 'Votre site présente un potentiel réel. Plusieurs priorités peuvent renforcer sa visibilité et son expérience.';

    var scoreRing = root.querySelector('[data-pw-score-ring]');
    scoreRing.style.setProperty('--pw-score-angle', Math.round(current / 100 * 360) + 'deg');

    var categories = ['SEO', 'Mobile', 'Performance', 'Conversion', 'Crédibilité'];
    root.querySelector('[data-pw-diagnostic-categories]').innerHTML = categories.map(function (category) {
      var categoryChecks = checks.filter(function (check) { return check[1] === category; });
      var categoryWeight = categoryChecks.reduce(function (sum, check) { return sum + check[5]; }, 0);
      var categoryEarned = categoryChecks.reduce(function (sum, check) { return sum + (check[0] ? check[5] : 0); }, 0);
      var categoryScore = categoryWeight ? categoryEarned / categoryWeight * 100 : current;
      return '<div class="pw-diagnostic__category"><strong>' + formatScore(categoryScore) + '</strong><span>' + category + '</span></div>';
    }).join('');

    var signals = passed.slice(0, 2).map(function (check) { return ['is-positive', '✓', check[2]]; });
    signals = signals.concat(failed.slice(0, 3).map(function (check) { return ['is-opportunity', '!', check[1] + ' à renforcer']; }));
    root.querySelector('[data-pw-diagnostic-signals]').innerHTML = signals.map(function (signal) {
      return '<li class="' + signal[0] + '"><span aria-hidden="true">' + signal[1] + '</span>' + signal[2] + '</li>';
    }).join('');

    var visibleOpportunities = failed.slice(0, 5);
    var issueCount = failed.length;
    root.querySelector('[data-pw-diagnostic-count]').textContent = issueCount;
    root.querySelector('[data-pw-diagnostic-opportunities]').innerHTML = visibleOpportunities.map(function (check, index) {
      return '<div class="pw-diagnostic__opportunity"><span class="pw-diagnostic__opportunity-number">' + String(index + 1).padStart(2, '0') + '</span><div><h3>' + check[3] + '</h3><p>' + check[4] + '</p></div></div>';
    }).join('');
    if (!visibleOpportunities.length) root.querySelector('[data-pw-diagnostic-opportunities]').innerHTML = '<p class="pw-diagnostic__all-clear">Aucun point prioritaire détecté par ce pré-diagnostic. Un audit humain peut vérifier l’expérience réelle et la performance.</p>';

    var locked = root.querySelector('[data-pw-diagnostic-locked]');
    var hiddenCount = Math.max(0, issueCount - visibleOpportunities.length);
    locked.hidden = hiddenCount === 0;
    if (hiddenCount) root.querySelector('[data-pw-diagnostic-locked-text]').textContent = hiddenCount + ' autres points d’optimisation révélés pendant l’audit';

    status.textContent = 'Diagnostic terminé';
    root.classList.remove('is-analyzing');
    root.classList.add('is-complete');
    progress.style.width = '100%';
    window.setTimeout(function () {
      loading.hidden = true;
      result.hidden = false;
      result.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, 450);
  }

  form.addEventListener('submit', function (event) {
    event.preventDefault();
    error.hidden = true;
    result.hidden = true;

    var url;
    try { url = normalizeUrl(input.value); }
    catch (e) { showError('Entrez une adresse de site valide.'); return; }

    var lastRun = Number(window.localStorage.getItem('pwDiagnosticLastRun') || 0);
    if (Date.now() - lastRun < 20000) { showError('Patientez quelques secondes avant de lancer une nouvelle analyse.'); return; }
    window.localStorage.setItem('pwDiagnosticLastRun', String(Date.now()));

    submit.disabled = true;
    root.classList.remove('is-complete');
    root.classList.add('is-analyzing');
    loading.hidden = false;
    status.textContent = messages[0];
    progress.style.width = '12%';
    var step = 0;
    timer = window.setInterval(function () {
      step = Math.min(step + 1, messages.length - 1);
      status.textContent = messages[step];
      progress.style.width = (18 + step * 20) + '%';
      root.querySelectorAll('[data-pw-live-signal]').forEach(function (signal, index) {
        signal.classList.toggle('is-active', index <= step);
      });
    }, 950);

    var extraction = {
      h1: { selectorAll: 'h1', attr: 'text' },
      h2: { selectorAll: 'h2', attr: 'text' },
      links: { selectorAll: 'a[href]', attr: 'href' },
      buttons: { selectorAll: 'a,button', attr: 'text' },
      images: { selectorAll: 'img', attr: 'outerHTML' },
      forms: { selectorAll: 'form', attr: 'outerHTML' },
      emails: { selectorAll: 'a[href^="mailto:"]', attr: 'href' },
      booking: { selectorAll: 'a[href*="cal.com"],a[href*="calendly"],a[href*="rendez-vous"],a[href*="reservation"]', attr: 'href' },
      socials: { selectorAll: 'a[href*="instagram.com"],a[href*="linkedin.com"],a[href*="facebook.com"],a[href*="tiktok.com"],a[href*="youtube.com"]', attr: 'href' },
      viewport: { selector: 'meta[name="viewport"]', attr: 'content' },
      og: { selector: 'meta[property="og:title"]', attr: 'content' },
      canonical: { selector: 'link[rel="canonical"]', attr: 'href' },
      jsonld: { selectorAll: 'script[type="application/ld+json"]', attr: 'text' },
      testimonials: { selectorAll: '[class*="testimonial"],[class*="review"],[class*="avis"]', attr: 'text' },
      faq: { selectorAll: '[class*="faq"],details', attr: 'text' }
    };
    var endpoint = 'https://api.microlink.io?url=' + encodeURIComponent(url.href) + '&data=' + encodeURIComponent(JSON.stringify(extraction)) + '&prerender=auto&ttl=1d';
    fetch(endpoint, { method: 'GET', mode: 'cors', credentials: 'omit' })
      .then(function (response) {
        if (!response.ok) throw new Error('api');
        return response.json();
      })
      .then(function (data) { window.clearInterval(timer); render(data, url); })
      .catch(function () {
        window.clearInterval(timer);
        root.classList.remove('is-analyzing');
        loading.hidden = true;
        showError('Nous n’avons pas réussi à analyser ce site. Vérifiez l’adresse et réessayez.');
      })
      .finally(function () { submit.disabled = false; });
  });

  var requestedUrl = new URLSearchParams(window.location.search).get('url');
  if (requestedUrl) {
    input.value = requestedUrl;
    form.requestSubmit();
  }
})();
